module.exports = __webpack_public_path__ + "static/fonts/gothamlight.ba0d530.woff";